import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Stethoscope, Users, ClipboardList, Clock, XCircle, CheckCircle2 } from "lucide-react";

const cards = [
  { key: "doctors", label: "Doctors", Icon: Stethoscope, tone: "text-emerald-700 bg-emerald-50" },
  { key: "patients", label: "Patients", Icon: Users, tone: "text-blue-700 bg-blue-50" },
  { key: "appointments", label: "Appointments", Icon: ClipboardList, tone: "text-slate-700 bg-slate-100" },
  { key: "upcoming", label: "Upcoming", Icon: Clock, tone: "text-amber-700 bg-amber-50" },
  { key: "completed", label: "Completed", Icon: CheckCircle2, tone: "text-emerald-700 bg-emerald-50" },
  { key: "cancelled", label: "Cancelled", Icon: XCircle, tone: "text-red-700 bg-red-50" },
];

export default function AdminDashboard() {
  const [stats, setStats] = useState({});
  useEffect(() => { api.get("/admin/stats").then((r) => setStats(r.data)); }, []);
  return (
    <div className="space-y-8">
      <div>
        <p className="text-sm text-slate-500">Admin overview</p>
        <h1 className="text-3xl font-bold text-slate-900">Platform at a glance</h1>
      </div>
      <div className="grid grid-cols-2 md:grid-cols-3 gap-4">
        {cards.map((c) => (
          <div key={c.key} className="doccare-card p-5">
            <div className={`w-9 h-9 rounded-xl grid place-items-center ${c.tone}`}><c.Icon className="w-4 h-4" /></div>
            <p className="mt-3 text-3xl font-bold text-slate-900" data-testid={`stat-${c.key}`}>{stats[c.key] ?? 0}</p>
            <p className="text-xs text-slate-500 uppercase tracking-wider font-semibold">{c.label}</p>
          </div>
        ))}
      </div>
    </div>
  );
}
